<template>
  <div class="m-4">
    <b-row v-for="(ruleSet, ruleSetIndex) in ruleSets" :key="ruleSetIndex">
      <b-col v-for="(rule, ruleIndex) in ruleSet.getRules()" :key="ruleIndex" class="pl-0 pt-2 mr-1">
        <b-input-group>
          <b-input-group-prepend>
            <b-button variant="outline-secondary" size="sm" @click="buttonPress_deleteRule(ruleSet, ruleIndex)">delete</b-button>
          </b-input-group-prepend>
          <b-form-input v-model="rule.symbol" size="sm" :state="rule.symbol.length !== 0"></b-form-input>
          <b-input-group-append>
            <b-button :variant="(rule.caseSensitive) ? 'primary' : 'outline-secondary'" size="sm" @click="() => rule.caseSensitive = !rule.caseSensitive">cs</b-button>
            <b-button :variant="(rule.wholeWord)     ? 'primary' : 'outline-secondary'" size="sm" @click="() => rule.wholeWord = !rule.wholeWord">hw</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-button variant="outline-info" class="my-2" size="sm" @click="buttonPress_addElement(ruleSet, ruleSetIndex)">+</b-button>
    </b-row>
    <!-- b-row>
      <b-button v-b-modal.modal-import-rule-set variant="primary" size="sm">import</b-button>
      <b-button v-b-modal.modal-export-rule-set variant="primary" size="sm">export</b-button>
    </b-row -->
    <b-modal id="modal-import-rule-set" title="import rule set" @ok="importRuleset()" size="xl">
      <p class="my-4">Import ruleSet</p>
      <b-form-textarea v-model="importRuleSetData" @focus="$event.target.select()" rows="24"/>
    </b-modal>
    <b-modal id="modal-export-rule-set" title="export rule set" @shown="exportRuleSet()" size="xl">
      <p class="my-4">Export ruleSet</p>
      <b-form-textarea disabled v-model="exportRuleSetData"  rows="24"/>
    </b-modal>
  </div>
</template>
<script>
  import BlockerFunctionRow from './BlockerFunctionRow.js';
  import BlockerFunctionTester from './BlockerFunctionTester.js';
  export default {
    props: [ 'value' ],
    data() {
      return {
        ruleSets: [],         
        importRuleSetData: null,
        exportRuleSetData: "",
        regex: ""
      }
    },
    methods: {
        buttonPress_addElement: function(ruleSet, index)
        {
          if((!ruleSet.hasRules()) && (index === (this.ruleSets.length - 1))) this.ruleSets.push(new BlockerFunctionRow());
          ruleSet.addElement();
        },
        buttonPress_deleteRule: function(ruleSet, index)
        {
          ruleSet.deleteRule(index);
          if(ruleSet.rules.length === 0) {
            this.ruleSets.splice(this.ruleSets.indexOf(ruleSet), 1);
          }
        },
        exportRuleSet: function()
        {
            this.exportRuleSetData = JSON.stringify(this.ruleSets.filter( elem => elem.rules.length > 0 ), null, 2);
            //this.value = this.exportRuleSetData;
            //this.$emit("input", { value: this.exportRuleSetData })
            this.$emit("input", this.exportRuleSetData)
            return JSON.stringify(this.ruleSets);
        },
        importRuleset: function(data)
        {
            this.importRuleSetData = data;
            if(this.importRuleSetData)
            {
                this.ruleSets = [];
                let raw = JSON.parse(this.importRuleSetData);
                raw.forEach((ruleSet) => {
                    this.ruleSets.push(new BlockerFunctionRow(ruleSet.rules));
                });
                if(this.ruleSets.length === 0 || !this.ruleSets.find( x => x.rules.length === 0))
                {
                    this.ruleSets.push(new BlockerFunctionRow());
                }
            }
        }
    },
    mounted() {
      if(this.value === '' || this.value === undefined || this.value === null)
      {
        this.ruleSets.push(new BlockerFunctionRow());
      }
      else
      {
        this.importRuleset(this.value);
      }
    }
  }
</script>
